import { useState } from 'react';
import { convertToEpoch, convertToEpoch2 } from '../../../../../utils/commonFunctions';
import { useAppDispatch } from '../../../../../app/redux/hooks';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';

export const useNotificationCalenderHooks = ({
  setValue,
  clearErrors,
  setGetStartDate,
  setGetEndDate,
  getStartDate
}: any) => {
  const [fromTimestamp, setFromTimeStamp] = useState<number | null>(null);
  const [currentTimestamp, setCurrentTimeStamp] = useState<number | null>(null);
  const [toDateDisabled, setToDateDisabled] = useState<boolean>(true);
  const dispatch = useAppDispatch();

  //function to handle From date
  const handleFromDate = (date: any) => {
    if (date === null) return;
    setGetStartDate(date?.$d);
    const fromDate: number | null = convertToEpoch2(date?.$d);
    setFromTimeStamp(fromDate);
    setCurrentTimeStamp(convertToEpoch(new Date()));
    setValue('startDate', date?.$d);
    clearErrors('startDate');
    clearErrors('endDate');
    setGetEndDate(new Date(date?.$d?.getTime() + 1000 * 600));
    setValue('endDate', new Date(date?.$d?.getTime() + 1000 * 600));
    if (date) {
      setToDateDisabled(false);
    }
    if (fromDate && currentTimestamp !== null && fromDate > currentTimestamp) {
      dispatch(
        updateToast({
          show: true,
          message: 'From date is Invalid',
          severity: 'error'
        })
      );
    }
  };

  //function to handle Custom date options in From date field
  const handleCustomFrom = (start: Date, end: Date) => {
    if (start) {
      setToDateDisabled(false);
    }
    setValue('startDate', start);
    setGetStartDate(start);
    setValue('endDate', end);
    clearErrors('startDate');
    clearErrors('endDate');
    setGetEndDate(end);
  };

  //function to handle Custom date options in To date field
  const handleCustomTo = (start: Date, end: Date) => {
    setValue('startDate', start);
    setGetStartDate(start);
    setValue('endDate', end);
    setGetEndDate(end);
    clearErrors('startDate');
    clearErrors('endDate');
  };

  //function to handle To date
  const handleToDate = (date: any) => {
    if (getStartDate === null) {
      setGetEndDate(date.$d);
      setValue('endDate', date?.$d);
      clearErrors('endDate');
      dispatch(
        updateToast({
          show: true,
          message: 'Please select "From Date"',
          severity: 'error'
        })
      );
    } else {
      setGetEndDate(date.$d);
      setValue('endDate', date?.$d);
      clearErrors('endDate');
    }
    const toDate: number | null = convertToEpoch2(date?.$d);
    if (toDate && fromTimestamp != null && toDate < fromTimestamp) {
      dispatch(
        updateToast({
          show: true,
          message: 'To Date is invalid',
          severity: 'error'
        })
      );
      setValue('endDate', date?.$d);
      clearErrors('endDate');
    }
  };

  return {
    handleToDate,
    handleCustomTo,
    handleCustomFrom,
    handleFromDate,
    toDateDisabled
  };
};
